import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("LessonsLoadingSpinner")
export class LessonsLoadingSpinner implements AxInit {
    public AxLoading: AxLoading;

    AxInit(init: any): void {
        this.AxLoading = new AxLoading();
    }

    StartLoadingSpinner(element) {
        let key = element;
        this.AxLoading.ShowLoadingIndicator($(key)[0]);
    }

    EndLoadingSpinner(element) {
        let key = element;
        this.AxLoading.HideLoadingIndicator($(key)[0]);
    }
}